export function fittingRoomOpenPayloadToPopupProps(payload) {
    return {
        product: payload.product,
        variant: payload.variant,
        heroImageUrl: payload.heroImageUrl,
        heroImageAlt: payload.heroImageAlt,
        colorLabel: payload.colorLabel,
        displayPriceRegular: payload.displayPriceRegular,
        displayPriceSale: payload.displayPriceSale,
        instoreMode: payload.isInstoreMode,
    };
}
